import zhHantMessages from '../locales/zh-Hant.json';

const ZhHantLan = {
  messages: {
    ...zhHantMessages,
  },
  locale: 'zh-Hant-HK',
};
export default ZhHantLan;
